import { useCallback, useMemo, useState } from 'react';
import { AnyObject } from '../types/types';

export type SearchTransformFn = (search: string) => AnyObject;
// the search transform is a function that receive the search and must return an object
export const useFilterLogic = (searchTransformFn: SearchTransformFn) => {
  const [search, setSearch] = useState('');
  const [filterLibby, setFilterLibby] = useState<AnyObject>({});
  const [filter, setFilter] = useState<AnyObject[]>([]);

  const updateFilterObject = useCallback((filters) => {
    const libbyFilter: AnyObject = {};

    [...filters].forEach(({ name, actives, alias }) => {
      const key = name;
      const path = alias;

      libbyFilter[key] = actives.map((value: any) => ({ path, value }));
    });

    setFilterLibby(libbyFilter);
  }, []);

  const updateFilter = useCallback(
    (newFilters) => {
      setFilter(newFilters);
      updateFilterObject(newFilters);
    },
    [updateFilterObject],
  );

  const amountOfFilters = useMemo(
    () => Object.values(filterLibby).reduce((acum, value) => acum + value.length, 0),
    [filterLibby],
  );

  const mergedFilter = useMemo(() => {
    if (!search || !searchTransformFn) {
      return filterLibby;
    }
    const searchFilter = searchTransformFn(search);
    return { ...filterLibby, ...searchFilter };
  }, [filterLibby, search, searchTransformFn]);

  return {
    search,
    setSearch,
    filterLibby: mergedFilter,
    filter,
    onFilterChange: updateFilter,
    amountOfFilters,
  };
};
